function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M43.2422 9.40527C33.6746 9.40527 23.7594 0.536719 23.6612 0.447873C23.0022 -0.149617 21.9977 -0.149617 21.3388 0.447873C21.24 0.537411 11.3508 9.40527 1.75781 9.40527C0.803211 9.40527 0.0292969 10.1792 0.0292969 11.1338V31.8343C0.0292969 48.6036 12.5018 55.3045 21.8835 58.8861C22.082 58.9619 22.291 58.9997 22.5 58.9997C22.709 58.9997 22.918 58.9618 23.1165 58.8861C36.271 53.8642 44.9707 46.0307 44.9707 31.8343V11.1338C44.9707 10.1792 44.1968 9.40527 43.2422 9.40527Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5 17.4004C15.8283 17.4004 10.4004 22.8283 10.4004 29.5C10.4004 36.1717 15.8283 41.5996 22.5 41.5996C29.1717 41.5996 34.5996 36.1717 34.5996 29.5C34.5996 22.8283 29.1717 17.4004 22.5 17.4004ZM27.1792 28.9937L21.9937 34.1792C21.6563 34.5167 21.2139 34.6855 20.7715 34.6855C20.3291 34.6855 19.8867 34.5168 19.5493 34.1792L17.8208 32.4507C17.1457 31.7756 17.1457 30.6813 17.8208 30.0062C18.4957 29.3312 19.5902 29.3312 20.2653 30.0062L20.7716 30.5125L24.735 26.5492C25.4099 25.8742 26.5044 25.8742 27.1794 26.5492C27.8544 27.2242 27.8544 28.3186 27.1792 28.9937Z",
  fill: "url(#paint1_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 22.5,
  y1: 58.9997,
  x2: 22.5,
  y2: -0.000272274,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00B59C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9CFFAC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 22.5,
  y1: 41.5996,
  x2: 22.5,
  y2: 17.4004,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C3FFE8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9973,
  stopColor: "#F0FFF4"
})));

function SvgShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 59,
    viewBox: "0 0 45 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.8951c94e.svg";
export { ForwardRef as ReactComponent };